export const contentSummaryWindows = Object.freeze({
  move: "move",
  outboundContent: "outboundContent",
});
